const AIDesk = {
  "结束会话": "Завершить сеанс ручного управления",
  "转人工服务": "Перевод на ручное обслуживание",
  "跳转":"Прыжок",
  "立即填写": "Заполнить сейчас",
  "已提交": "Отправлено",
  "提交": "Отправить",
  "查看内容": "Просмотреть содержимое",
  "请填写必填项": "Пожалуйста, заполните обязательные поля",
  "请输入内容":"Пожалуйста, введите содержание",
  "如果满意请给好评哦～":"Если вы удовлетворены, пожалуйста, оставьте хороший отзыв~",
  "请对本次服务进行评价": "Оцените обслуживание",
  "提交评价": "Отправить оценку",
  "服务评价": "Оценка услуги",
  "并发限制": "В данный момент слишком много пользователей. Попробуйте позже",
  "分支选项异常": "Содержимое аномально, пожалуйста, проверьте конфигурацию потока задач",
  "满意": "Доволен",
  "不满意": "Не доволен",
  "感谢您的反馈，我们会持续优化改进": "Спасибо за ваш отзыв, мы будем продолжать улучшать",
  "您遇到了哪方面的问题": "С какой проблемой вы столкнулись",
  "其他反馈内容": "Другой отзыв",
  "取消": "Отмена",
  "答非所问": "Несоответствующий ответ",
  "未匹配相关内容": "Нет соответствующего содержания",
  "信息错误": "Ошибочная информация",
  "上下文理解错误": "Ошибка понимания контекста",
  "格式不规范": "Нестандартный формат",
  "内容不完整": "Неполное содержание",
  "file 大小超过 100MB，无法发送": "Размер файла превышает 100MB, отправка невозможна",
  "image 大小超过 20MB，无法发送": "Невозможно отправить изображение, так как оно превышает 20 MB",
  "video 大小超过 100MB，无法发送": "Невозможно отправить видео, так как оно превышает 100 MB",
  "提交成功": "Успешно отправлено",
  "userID 只能包含可打印 ASCII 字符": "UserID должен содержать только печатные символы ASCII",
  "userID 不能包含'administrator'": "UserID не должен содержать 'administrator'",
  "userID 长度不能超过45字节": "Длина UserID не должна превышать 45 байт",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "Мы ценим ваши отзывы. Пожалуйста, поделитесь предложениями, которые помогут нам стать лучше.",
  "排队等待中": "В ожидании в очереди",
  "排队等待话术": "Извините, все наши операторы сейчас заняты. Пожалуйста, ожидайте, мы скоро будем с вами. Благодарим за понимание.",
  "当前前方排队人数": "Текущее количество человек впереди в очереди",
  "结束排队": "Выйти из очереди",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "Отзыв нельзя изменить после истечения 3 минут с момента отправки.",
  "不能发送空白消息": "Невозможно отправить пустое сообщение",
  "确认转人工": "Подтвердить перевод на оператора",
}
export default AIDesk;
